<template>
  <div class="filter-menu" :class="show ? 'open' : 'closed'">
    <div class="filters-button">
      <base-button v-show="show" :rounded="true" background-color="#ea1d75" @click.prevent="closeFilter">
        <img class="rotate" style="width: 25px; margin: 0 auto;" src="../assets/icons/close.svg" alt="">
      </base-button>
    </div>
    <div class="filter-body">
      <base-select v-model="selectedPivot" label="Pivote" :options="pivots" />
      <base-button background-color="#ea1d75" @click.prevent="getPivotData" :disabled="disablePivotDataRequest">Definir pivote</base-button>
      <div v-show="showFiltersOptions">
        <base-select v-model="selectedClassification" label="Clasificación"  @change.prevent="setBrands" :options="classifications"/>
        <base-select v-show="showBrands" v-model="selectedBrand" label="Marca" :options="brands"/>          
        <input placeholder="Competencia" v-model="otherPivots" class="input-container" v-show="showOthersIdsInput" type="text" id="others-ids">
        <base-button v-show="showOthersIdsInput" @click="getSimilars()" background-color="#ea1d75">Solicitar similares</base-button>
      </div>
    </div>
  </div>
</template>
<script>
import RequestService from '@/services/RequestService.js'
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    currentPage: {
      type: [String, Number],
      default: 0,
    }
  },
  data() {
    return {
      selectedPivot: '',
      pivots: [],
      selectedClassification: '',
      classifications: [],
      selectedBrand: '',
      brands: [],
      otherPivots: '',
      pivotProduct: {},
      otherPivotsProducts: [],
    };
  },
  methods: {
    closeFilter() {
      this.$emit('closeFilters')
    },
    getPivots() {
      RequestService.getPivots()
        .then((response) => {
          this.pivots = [{name: 'Seleccione un pivote'}, ...response.data]
        })
    },
    getPivotData() {
      RequestService.getPivotData(this.selectedPivot)
        .then((response) => {
          this.classifications = [{name: 'Seleccione una clasificación'}, ...response.data]
        })
    },
    getSimilars(page) {
      this.$emit('clearMinisFromFilters')
      const nextPage = page ? page : 1
      RequestService.getSimilars(this.selectedPivot, this.selectedClassification, this.selectedBrand, this.otherPivots, nextPage)
        .then((response) => {
          this.pivotProduct = response.data.pivot
          this.otherPivotsProducts = response.data.others
          this.otherPivotsProducts[0].selected = true
          this.$emit('receive-info', [this.pivotProduct, this.otherPivotsProducts, response.data.page, response.data.total])
        })
    },
    setBrands() {
      let brands = this.classifications.filter(classification => classification.id === this.selectedClassification)
        .map(classification => classification.brands)
      brands = brands[0].map(brand => {
        return {
          id: brand,
          name: brand,
        }
      })
      this.brands = [{name: 'Seleccione una marca'}, ...brands]
    }
  },
  computed: {
    disablePivotDataRequest() {
      return this.selectedPivot === ''
    },
    showFiltersOptions() {
      return this.classifications.length > 0
    },
    showBrands() {
      return this.selectedClassification !== ''
    },
    showOthersIdsInput() {
      return this.selectedBrand !== ''
    }
  },
  created() {
    this.getPivots()
  }
}
</script>
<style scoped>
.default {
  background-color: red;
}
.rotate {
  transition: all 1s;
}
.rotate:hover  {
  transform: rotate(360deg);
}
.filter-menu {
  width: 240px;
  height: 100vh;
  background-color: #621f65;
  position: absolute;
  top: 0;
  padding: 0 30px;
  z-index: 2;
  transition: all 0.5s;
}
.open {
  right: 0;
}
.closed {
  right: -300px;
}
.filter-body {
  margin: 100px auto 100px auto;
}
.input-container {
  margin-top: 50px;
  margin-bottom: 10px;
}
</style>
